import React from 'react'

const DotsLoader = () => {
  return (
    <div>
         <div className="loader"></div>
    </div>
  )
}

export default DotsLoader
